
<anime
  :enter="enter"
  :leave="leave"
  :before-enter="beforeEnter"
>
  <div
    v-if="open"
    class="page-preview-dialog"
  >
    <div class="dot-grid" />
    
    <cvt-top-nav-bar
      mode="LIGHT"
      variant="embedded"
      route="preview"
      :fixed="true"
      :template-name="title"
      :type="orgName"
      @home="cancelPreview"
      @exit-preview="cancelPreview"
      @switch-preview="switchPreview"
      @use-template="clickedUseTemplate"
    />

    <left-side-bar v-if="isGridBuilder" :is-template="isTemplate" />

    <div class="page-preview-dialog__window">
      <div
        v-if="!isGridBuilder"
        v-show="loading"
        class="page-preview-dialog__window__loader"
      >
        <h1>{{ $t(`editor.message.redirect_msg.${showRedirectMsg}`) }}</h1>
        <loader-square />
      </div>

      <embed
        v-if="isGridBuilder && url != ''"
        :src="previewUrl"
        :class="mode"
        width="95%"
        height="95%"
        type="text/html"
      >

      <iframe
        v-if="!isGridBuilder  && url != ''"
        v-show="!loading"
        :class="mode"
        :src="previewUrl"
        frameborder="0"
        @load="iframeLoaded"
      />
    </div>
  </div>
</anime>
